import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from '@cancercentrum/rcc-bootstrap';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faShareFromSquare } from '@fortawesome/free-regular-svg-icons';
export const RetakeModal = (props)=>{
    const { onCancel, onSuccess } = props;
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: "Återta ärende"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx("p", {
                    children: "Ärendet kommer att flyttas till RCC:s inkorg."
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faShareFromSquare,
                        bsStyle: "success",
                        className: "mr-2",
                        onClick: ()=>onSuccess('Återta_som_monitor'),
                        children: "Återta"
                    })
                ]
            })
        ]
    });
};
